/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Inline_FallbackInputs */

const en_directory_submit_enrich_inline_fallback = /** @type {(inputs: Directory_Submit_Enrich_Inline_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can still fill the form manually below.`)
};

const zh_directory_submit_enrich_inline_fallback = /** @type {(inputs: Directory_Submit_Enrich_Inline_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你仍可以在下方手动填写表单。`)
};

/**
* | output |
* | --- |
* | "You can still fill the form manually below." |
*
* @param {Directory_Submit_Enrich_Inline_FallbackInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_inline_fallback = /** @type {((inputs?: Directory_Submit_Enrich_Inline_FallbackInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Inline_FallbackInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_inline_fallback(inputs)
	return zh_directory_submit_enrich_inline_fallback(inputs)
});
export { directory_submit_enrich_inline_fallback as "directory.submit.enrich.inline_fallback" }